import { createActionConst } from '../../../utils/action.utils';

const COMPANY_CONTEXT_NAMESPACE = 'COMPANY_CONTEXT_PAGE';

export const COMPANY_CONTEXT_PAGE = createActionConst(COMPANY_CONTEXT_NAMESPACE, 'COMPANY_CONTEXT_PAGE');
export const CREATE_COMPANY_CONTEXT = createActionConst(COMPANY_CONTEXT_NAMESPACE, 'CREATE_COMPANY_CONTEXT');
export const UPDATE_COMPANY_CONTEXT = createActionConst(COMPANY_CONTEXT_NAMESPACE, 'UPDATE_COMPANY_CONTEXT');
export const DELETE_COMPANY_CONTEXT = createActionConst(COMPANY_CONTEXT_NAMESPACE, 'DELETE_COMPANY_CONTEXT');
